import React from 'react';
import {makeStyles} from '@mui/styles';
import PropTypes from "prop-types";
import {SpeedDial, SpeedDialAction, SpeedDialIcon} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    speedDial: {
        position: 'absolute',
        margin: theme.spacing(2),
    },
}));

export default function SpeedDials(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const {actions} = props;

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <SpeedDial
            ariaLabel="SpeedDial-Viewer"
            className={classes.speedDial}
            icon={<SpeedDialIcon/>}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction="right"
            FabProps={{color: "secondary"}}
        >
            {actions.map((action) => (
                <SpeedDialAction
                    key={action.name}
                    FabProps={{id: action.id}}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    tooltipPlacement={"bottom"}
                />
            ))}
        </SpeedDial>
    );
}

SpeedDials.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            icon: PropTypes.object.isRequired,
            name: PropTypes.string.isRequired
        })).isRequired
}
